export default __webpack_public_path__ + "static/media/9efae8bd_1.c93edc80.png";